import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card, Table } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import DocumentUploader from './DocumentUpload';
import { getTicketDocuments } from '../../services/sTicket/ticket.service';
import * as actionsTicket from '../../actions/ticket-action';
import * as actionsAnswer from '../../actions/answer-action';
import { useDispatch } from 'react-redux';

const SidePanelDocument = (props) => {
    const { t } = useTranslation();
    
    const dispatch = useDispatch();
    
    const { 
        inputParam_IsPanelOpen = null, 
        inputParam_SetterIsPanelOpen = null,     
        ticket_id = null,
        ticket_answer_id = null
    } = props;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    



    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setListLoaded(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };


    const onClosePanel = () => {
        onDismissPanel();
    };
    const onSaveConfiguration = () => {
        onDismissPanel();
    };

    
    const addFormRef = useRef(null);
    
    

  const handleRefreshDocuments = () => {
    // Llama al método handleFormSubmit de AddForm
    
    if(ticket_answer_id){
        dispatch(actionsAnswer.addDocumentFlag(ticket_answer_id));
    }
    else{
        dispatch(actionsTicket.addDocumentFlag(ticket_id));
    }

    
    setListLoaded(false);
  };

    const [ticketDocuments, setTicketDocuments] = useState([]);
    const [listLoaded, setListLoaded] = useState(false);
    
  
    useEffect(() => {            
            if(inputParam_IsPanelOpen && !listLoaded)
            {
                setLoad();
                
            }
            
    }, [listLoaded, inputParam_IsPanelOpen]);

    const setLoad = async ()=> {
        try{
            
                let docs = await getTicketDocuments(ticket_id, ticket_answer_id);
                if(docs === null)
                    docs = [];            
                setTicketDocuments(docs.data.data);        
                setListLoaded(true);
        }
        catch (error){

        }

        
    }

    const generateUniqueKey = (prefix, id) => `${prefix}_${id}_${Math.random()}`;

    const allTableItems = ticketDocuments?.length > 0 ? ticketDocuments.map(tableItem => (
    <tr key={generateUniqueKey("documents", tableItem.id)}>
        <td>{tableItem.name}</td><td>{tableItem.uploadDate}</td>
    </tr>
    )) : [];
    
    

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        Mensajes
                    </Col>
                    <Col xl={12}>                        
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText="adding"
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <>      

                {ticketDocuments != null &&                 
                    <Table>
                        <tbody>
                            {allTableItems}
                        </tbody>
                    </Table>
                }

                    <DocumentUploader ticket_id={ticket_id} ticket_answer_id={ticket_answer_id} handleRefreshDocs={handleRefreshDocuments}></DocumentUploader>
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelDocument.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,  
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,      
};

export default SidePanelDocument;